
import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';

const PartnerFounderOffer = () => {
  const offers = [
    "No startup cost",
    "Zip code exclusivity", 
    "White-labeled platform options",
    "First 25 members seeded for free",
    "Founder pricing for early locations"
  ];

  return (
    <section className="py-32 bg-gradient-to-br from-juv-terracotta to-juv-rose-clay text-white">
      <div className="container mx-auto px-6 max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-5xl md:text-6xl font-serif font-light mb-8">
            Founder Pilot Offer
          </h2>
          <p className="text-xl text-white/90 mb-12">
            We're onboarding 100 offices. Reserve your territory today.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="bg-white/10 backdrop-blur-sm rounded-3xl p-12 max-w-4xl mx-auto"
        >
          <div className="grid md:grid-cols-2 gap-8">
            <div className="space-y-6">
              {offers.map((offer, index) => (
                <div key={index} className="flex items-center space-x-4">
                  <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center">
                    <Check className="w-5 h-5 text-juv-terracotta" />
                  </div>
                  <span className="text-lg text-white/95">{offer}</span>
                </div>
              ))}
            </div>
            
            <div className="bg-white/10 rounded-2xl p-8">
              <h3 className="text-2xl font-semibold mb-4">Limited Time</h3>
              <p className="text-white/90 leading-relaxed">
                This exclusive founder offer is only available to the first 100 practices that join our pilot program. 
                Each market will be limited to ensure territory exclusivity for our founding partners.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PartnerFounderOffer;
